import { schema } from "normalizr";
export const submissionAgent = new schema.Entity("submissionAgent");
export const submissionAgentsSchema = new schema.Entity("submissionAgents", {
  submissionAgents: [submissionAgent]
}, {
  idAttribute: "submissionAgentId"
});
export const creditReport = new schema.Entity("creditReport");
export const creditReportsSchema = new schema.Entity("creditReports", {
  creditReports: [creditReport]
}, {
  idAttribute: "id"
});
const latestTimestamp = (a, b) => {
  const aTimeStamp = new Date(a.mppApplicationTimestamp);
  const bTimeStamp = new Date(b.mppApplicationTimestamp);
  return aTimeStamp > bTimeStamp ? a : b;
};
export const mpp = new schema.Entity("mpp");
export const mppSchema = new schema.Entity("mpp", {
  mpp: [mpp]
}, {
  idAttribute: "submissionId",
  mergeStrategy: latestTimestamp
});
export const submissionRecord = new schema.Entity("submissionRecord");
export const submissionHistorySchema = new schema.Entity("submissionHistory", {
  submissionHistory: [submissionRecord]
}, {
  idAttribute: "submissionId"
});
export const commissionDeduction = new schema.Entity("commissionDeduction");
export const commissionDeductionsSchema = new schema.Entity("commissionDeductions", {
  commissionDeductions: [commissionDeduction]
}, {
  idAttribute: "commissionsDeductionId"
});
export const commissionParticipant = new schema.Entity("commissionsParticipant");
export const commissionParticipantsSchema = new schema.Entity("commissionParticipants", {
  commissionParticipants: [commissionParticipant]
}, {
  idAttribute: "commissionsParticipantId"
});
export const commissionsFee = new schema.Entity("commissionsFees");
export const commissionsFeesSchema = new schema.Entity("commissionsFees", {
  documents: [commissionsFee]
}, {
  idAttribute: "commissionsFeeId"
});